import { useEffect } from 'react';

let timer;
function useDebounce(defalut_delay: number = 1500): [(FN?: Function, delay?: number) => Promise<void>] {
  const debounce = (FN: Function, delay: number = defalut_delay): Promise<void> => {
    return new Promise((resolve, reject) => {
      clearInterval(timer);
      timer = setTimeout(() => {
        FN && FN();
        resolve();
      }, delay);
    });
  };

  useEffect(() => {
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return [debounce];
}

export default useDebounce;
